import React from 'react';
import { Field } from 'redux-form';
import { t } from 'i18next';
import Checkbox from '../../../../lib/ui/form_elements/Checkbox';
import {
  Container,
  Title,
  ScrollBox,
  TermsContent,
  CheckboxWrapper,
} from './css';

const TermsAndConditionsPreferences = () => {
  const bolTermsUrl = t('BOLTermsUrl');
  const linkText = t('BOLTermsLinkText');
  const beforeLink = t('BOLTermsCheckboxBefore');
  const afterLink = t('BOLTermsCheckboxAfter');

  const checkboxLabel = (
    <span>
      {beforeLink}
      <a href={bolTermsUrl} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
      {afterLink}
    </span>
  );

  return (
    <Container>
      <Title>{t('TermsAndConditionsTitle')}</Title>
      <ScrollBox>
        <TermsContent>
          <h4>{t('BOLTermsMainTitle')}</h4>
          <h4>{t('BOLTermsSection1Title')}</h4>
          <p>{t('BOLTermsSection1Text')}</p>
          <h4>{t('BOLTermsSection2Title')}</h4>
          <p>{t('BOLTermsSection2Text1')}</p>
          <p>{t('BOLTermsSection2Text2')}</p>
          <h4>{t('BOLTermsSection3Title')}</h4>
          <p>{t('BOLTermsSection3Text')}</p>
          <h4>{t('BOLTermsSection4Title')}</h4>
          <p>{t('BOLTermsSection4Text')}</p>
          <h4>{t('BOLTermsSection5Title')}</h4>
          <p>{t('BOLTermsSection5Text')}</p>
        </TermsContent>
      </ScrollBox>
      <CheckboxWrapper>
        <Field
          name="termsAccepted"
          component={Checkbox}
          label={checkboxLabel}
          type="checkbox"
        />
      </CheckboxWrapper>
    </Container>
  );
};

export default TermsAndConditionsPreferences;
